import { render, staticRenderFns } from "./GoodsPreview.vue?vue&type=template&id=fbe3d53a&scoped=true"
import script from "./GoodsPreview.vue?vue&type=script&lang=js"
export * from "./GoodsPreview.vue?vue&type=script&lang=js"
import style0 from "./GoodsPreview.vue?vue&type=style&index=0&id=fbe3d53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe3d53a",
  null
  
)

export default component.exports